__turbopack_context__.v({
  "className": "sfprodisplaymedium_5c850e1d-module__NC1a-a__className",
  "variable": "sfprodisplaymedium_5c850e1d-module__NC1a-a__variable",
});
